"use strict";

exports.__esModule = true;
exports.formFieldsetPropTypes = exports.formFieldDividerPropTypes = exports.formFieldPropTypes = void 0;

var _propTypes = require("prop-types");

var _propTypes2 = require("../utils/propTypes");

var _constants = require("./constants");

var formFieldPropTypes = {
  caption: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  children: _propTypes.node,
  hideLabel: _propTypes.bool,
  id: _propTypes.string,
  input: _propTypes2.component,
  rootProps: _propTypes.object,
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]).isRequired,
  required: _propTypes.bool,
  requiredText: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  secondaryText: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  variant: (0, _propTypes.oneOf)(Object.keys(_constants.VARIANT))
};
exports.formFieldPropTypes = formFieldPropTypes;
var formFieldDividerPropTypes = {};
exports.formFieldDividerPropTypes = formFieldDividerPropTypes;
var formFieldsetPropTypes = {
  children: _propTypes.node,
  disabled: _propTypes.bool,
  legend: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element])
};
exports.formFieldsetPropTypes = formFieldsetPropTypes;